import style from './HeroBanner.module.css'
import brainVideo from '../../../assets/images/brain.mp4'
import { useNavigate } from 'react-router-dom'
import useWindowWidth from '../../../hooks/useWindowWidth'
import GuestContext from '../../../contexts/GuestContext'
import { useContext, useCallback, useEffect, useRef,useState  } from 'react'

const HeroBanner = () => {
  const innerWidth = useWindowWidth()
  const navigate = useNavigate()
  const { setOpenGuestInfo } = useContext(GuestContext)
  const videoRef = useRef(null)
  const TYPED_TEXT = `Hi I'm Chimp! 👋`
  const [typed, setTyped] = useState('')
  const [typingDone, setTypingDone] = useState(false)

  // type on mount
  useEffect(() => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    if (reduce) { setTyped(TYPED_TEXT); setTypingDone(true); return }

    let i = 0
    const interval = setInterval(() => {
      i += 1
      setTyped(TYPED_TEXT.slice(0, i))
      if (i >= TYPED_TEXT.length) {
        clearInterval(interval)
        setTypingDone(true)
      }
    }, 55) // typing speed (ms per char). Tweak as you like.

    return () => clearInterval(interval)
  }, [])
  const handleNavigation = useCallback((path, sectionId) => {
    navigate(path)
    setTimeout(() => {
      const section = document.getElementById(sectionId)
      if (section) section.scrollIntoView({ behavior: 'smooth' })
    }, 200)
  }, [navigate])

  const openLogin = () => {
    if (typeof setOpenGuestInfo === 'function') setOpenGuestInfo(true)
    navigate('/?auth=login')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Ensure autoplay + continuous playback (iOS/Safari friendly)
  useEffect(() => {
    const v = videoRef.current
    if (!v) return
    const tryPlay = () => {
      v.muted = true
      v.play().catch(() => {})
    }
    v.addEventListener('canplay', tryPlay)
    v.addEventListener('ended', tryPlay)
    tryPlay()
    return () => {
      v.removeEventListener('canplay', tryPlay)
      v.removeEventListener('ended', tryPlay)
    }
  }, [])

  const isMobile = innerWidth < 768

  // Desktop fit: 'contain' avoids vertical cropping; switch to 'cover' if you want cinematic crop.
  const desktopFit = 'contain' // 'contain' | 'cover'

  return (
  <section className={style.mainContainer} aria-label="Hero banner">
    <div
      className={[
        style.videoWrapper,
        innerWidth < 768 ? style.mobileFlow : '',
        desktopFit === 'contain' ? style.noCrop : ''
      ].join(' ')}
      aria-hidden="true"
    >
      <video
        ref={videoRef}
        className={`${style.backgroundVideo} ${
          innerWidth < 768
            ? style.fitContain
            : desktopFit === 'cover'
              ? style.fitCover
              : style.fitContain
        }`}
        src={brainVideo}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        style={{ '--video-pos-x': '50%', '--video-pos-y': '45%' }}
      />
      <div className={style.videoDim} />
      <div className={style.videoGlass} />
    </div>

      <div className={style.container}>
        <div className={style.content}>
          <p className={style.heroTagline}>Every career needs a companion. Meet yours.</p>¨
          <p
            className={style.heroIntro}
            aria-live="polite"
            aria-atomic="true"
          >
            {typed}
            <span
              className={`${style.caret} ${typingDone ? style.caretIdle : ''}`}
              aria-hidden="true"
            />
          </p>
          <p className={style.heroSubText}>
            Chimp is the personal, intelligent space for your career—quiet, focused, and always one step ahead.
          </p>
          <div className={style.actions}>
            <button className={style.primaryBtn} onClick={openLogin}>Get Early Access</button>
            <button className={style.secondaryBtn} onClick={() => handleNavigation('/', 'bot-hero')}>Get to Know More</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroBanner
